import { useQuery } from "react-query";
import { IPartialSumParams } from "types/UserOrder";
import { fetchAPIPartialSum } from "../requests/UserOrders";

export function useQueryPartialSum(params: IPartialSumParams) {
    const onError = () => {};
    const query = useQuery(
        "apiPartialSum",
        async () => await fetchAPIPartialSum(params),
        {
            onError,
        }
    );
    return query;
}
